var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"kvass-media-description",attrs:{"type":"text","placeholder":_vm.placeholderComp},domProps:{"value":_vm.value},on:{"input":($ev) => _vm.$emit('input', $ev.target.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }